import { default as RadioMaterialUI } from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import React from 'react';
import theme from './../../../lib/theme';
import Label from './Label';

const styles = {
  root: {
    height: '100%',
    width: '15px',
    marginRight: '7px',
    '&$checked': {
      color: theme.colors.primary['blue-2'],
    },
  },
  checked: {},
  sizeIcon: {
    fontSize: 15,
  },
};

const Radio = ({ label, isChecked, handleChange, classes }) => {
  return (
    <Label label={label} htmlFor={label}>
      <RadioMaterialUI
        id={label}
        checked={isChecked}
        onChange={handleChange}
        classes={{
          root: classes.root,
          checked: classes.checked,
        }}
        icon={<RadioButtonUncheckedIcon className={classes.sizeIcon} />}
        checkedIcon={<RadioButtonCheckedIcon className={classes.sizeIcon} />}
      />
    </Label>
  );
};

export default withStyles(styles)(Radio);
